module.exports = __webpack_public_path__ + "static/assets/b1cd6062245fae73f539ff410e499f34.svg";